import React from 'react';

import { CarrierFactory } from '../../../../../../common/carrierConfig/carrierFactory';
import { Carriers } from '../../../../../../common/constants/carriers';
import { DrawerLetterBody } from '../../drawer/DrawerLetterBody';
import { LetterFormData } from '../hooks/useLetterForm';
import { LetterTypes, Sources } from '../types';

export interface DeclineLetterContentProps {
  source: Sources;
  formData: LetterFormData;
  carrier: Carriers;
  isJuvenile?: boolean;
}

const DeclineLetterContent = ({
  source,
  formData,
  carrier,
  isJuvenile = false,
}: DeclineLetterContentProps) => (
  <DrawerLetterBody
    letterType={LetterTypes.decline}
    pricingMode="higher"
    isJuvenile={isJuvenile}
    carrier={carrier}
    carrierDisplayName={
      CarrierFactory.getCarrierConfig(carrier)?.getCarrierDisplayName() ?? ''
    }
    riders={[]}
    selectedRiders={[]}
    selectedSources={[source]}
    fieldValues={formData as Record<string, string>}
    hasFcra={false}
  />
);

export default DeclineLetterContent;
